import React, { useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  Box,
  Button,
  Flex,
  FormControl,
  Heading,
  Input,
  Text,
  useColorModeValue,
  Alert,
  AlertIcon,
  Icon,
  InputRightElement,
  InputGroup
} from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { FormLabel } from "@chakra-ui/form-control";
import axios from "axios";
// Custom components
import DefaultAuth from "layouts/auth/Default";
// Assets
import illustration from "assets/img/layout/app_logo.png";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";

function ForgotPassword() {
  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const textColorSecondary = "gray.400";

  const passwordResetToken = new URLSearchParams(window.location.search).get('token');
  const passwordRef = useRef(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);

  const handleForgot = () => {
    setMessage("");
    setError("");
    const password = passwordRef.current.value;
    if (!password) {
      setError("Ingen passord oppgitt.");
      return;
    }
    if (!passwordResetToken) {
      setError("Ingen token oppgitt.");
      return;
    }
    axios.post("https://api.beehiveproject.no/auth/reset-password", {
      password,
      token: passwordResetToken
    })
      .then(() => setMessage("Passordet er endret."))
      .catch(() => setError("Feilet å endre passord. Prøv igjen."));
  };

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration} imageStyle={{ width: '300px' }}>
      <Flex
        maxW={{ base: "100%", md: "max-content" }}
        w='100%'
        mx={{ base: "auto", lg: "0px" }}
        me='auto'
        h='100%'
        alignItems='start'
        justifyContent='center'
        my={{ base: "30px", md: "auto" }}
        px={{ base: "25px", md: "0px" }}
        flexDirection='column'>
        <Box me='auto'>
          <Heading color={textColor} fontSize='36px' mb='10px'>
            Endre Passord
          </Heading>
        </Box>
        <Flex
          zIndex='2'
          direction='column'
          w={{ base: "100%", md: "420px" }}
          maxW='100%'
          background='transparent'
          borderRadius='15px'
          mx={{ base: "auto", lg: "unset" }}
          me='auto'
          mb={{ base: "20px" }}>
          <FormControl>
            <FormLabel
              display='flex'
              ms='4px'
              fontSize='sm'
              fontWeight='500'
              color={textColor}
              mb='8px'>
              Passord<Text color={brandStars}>*</Text>
            </FormLabel>
            <InputGroup size='md'>
              <Input
                ref={passwordRef}
                isRequired={true}
                variant='auth'
                fontSize='sm'
                ms={{ base: "0px", md: "0px" }}
                type={show ? "text" : "password"}
                placeholder='passord'
                mb='24px'
                fontWeight='500'
                size='lg'
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    handleForgot();
                  }
                }}
              />
              <InputRightElement display='flex' alignItems='center' mt='4px'>
                <Icon
                  color={textColorSecondary}
                  _hover={{ cursor: "pointer" }}
                  as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={() => setShow(!show)}
                />
              </InputRightElement>
            </InputGroup>
          </FormControl>
          <Flex justifyContent='space-between' align='center' mb='24px'>
            <NavLink to='/auth/sign-in'>
              <Text
                color={textColorBrand}
                fontSize='sm'
                w='150px'
                fontWeight='500'
                display='flex'
                alignItems='center'
                >
                <Icon as={ArrowBackIcon} w={4} h={4} me={2}  cursor="pointer" />
                Tilbake til logg inn
              </Text>
            </NavLink>
          </Flex>
          <Button
            fontSize='sm'
            variant='brand'
            fontWeight='500'
            w='100%'
            h='50'
            mb='24px'
            onClick={handleForgot}>
            Endre Passord
          </Button>
          {message && <Alert status="success" mt={4} borderRadius="16px"><AlertIcon />{message}</Alert>}
          {error && <Alert status="error" mt={4} borderRadius="16px"><AlertIcon />{error}</Alert>}
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}

export default ForgotPassword;